import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import WishListContext, {useWishListContext, WishListController} from "../../../../reducer/moduleReducer/wishList";
import Buffer from "../../../../publicComponent/Buffer";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import Pagination from "../../../../publicComponent/Pagination";

function ListWrap({ gotoProductDetail, getWishList ,delWish}) {
  const { state } = useWishListContext();
  const { wishListLoading, wishList, total, query } = state;
  const { t } = useTranslation();
  
  return (
    <>
      <Buffer.Loading loading={wishListLoading}/>
      {
        wishList.length > 0
          ? <>
            <div className="relative grid grid-cols-4 xlg:gap-12 md:gap-7 pb-[53px] md:mb-[45px]
                        mdmax:grid-cols-1 md:py-[12px] mdmax:mx-[3%]">
              {
                wishList.map((data, i) => {
                  const item = data.itemInfo;
                  return (
                    <div className="relative grid grid-rows-1 mdmax:flex cursor-pointer md:mb-[40px] mdmax:mb-[12px]"
                         key={i}>
                      <div className="cursor-pointer overflow-hidden flex-none mdmax:w-[130px] mdmax:h-[130px]
                                    mdmax:rounded-[10px] mdmax:mr-[15px] bg-white row-span-1 flex items-center"
                           onClick={() => gotoProductDetail(item.itemId)}>
                        <img src={item.mainPicView} className="w-[100%]"/>
                      </div>
                      <div className="left-0 md:pt-[12px] bottom-[32px] mdmax:bottom-[15px] w-[100%] mdmax:pt-[12px]">
                        <p className="text-lg line-clamp-1 cursor-pointer"
                           onClick={() => gotoProductDetail(item.itemId)}
                           style={{ lineHeight: '18px' }}>
                          {item.itemName}
                        </p>
                        <div className="flex items-center justify-between">
                          <p className="my-[12px] font-bold text-[14px]">
                            ${item.minPrice} - {item.maxPrice}
                          </p>
                          <p onClick={() => delWish(data.sourceId)}><i className="iconfont icon-favorite text-[20px] text-[#e30707]"/></p>
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </div>
            <Pagination total={total}
                        current={query.page}
                        pageSize={query.limit}
                        onChange={(page) => getWishList({ page })}/>
          </>
          : <Buffer.Empty content={t('抱歉！暂时还没有商品')}/>
      }
    </>
  );
}

function WishListWrap() {
  const { getWishList, gotoProductDetail ,delWish} = WishListController();
  const { state } = useWishListContext();
  const { wishListLoading } = state;
  const { t } = useTranslation();
  useEffect(() => {
    getWishList({ collectType: 1 });
  }, []);
  
  return (
    <Navigator.container className="container-center md:mt-[30px]">
      <div className="mdmax:hidden mb-[25px]">
        <h1 className="text-[18px] mb-[25px] font-bold">{t('心愿单')}</h1>
        <ListWrap
          gotoProductDetail={gotoProductDetail}
          getWishList={getWishList}
          delWish={delWish}/>
      </div>
    </Navigator.container>
  );
}

export default function WishList() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title={'心愿单'}/>
      <WishListContext>
        <WishListWrap/>
      </WishListContext>
    </>
  );
}
